import { render, staticRenderFns } from "./CreateMailMega.vue?vue&type=template&id=27cd0098&scoped=true&"
import script from "./CreateMailMega.vue?vue&type=script&lang=js&"
export * from "./CreateMailMega.vue?vue&type=script&lang=js&"
import style0 from "./CreateMailMega.vue?vue&type=style&index=0&id=27cd0098&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cd0098",
  null
  
)

export default component.exports